export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:9000';

export const NETWORK_CHAIN_IDS = process.env.REACT_APP_NETWORK_CHAIN_IDS || 0x61;

export const DISPERSE_MULTI_SENDER_CONTRACT_ADDRESS = process.env.REACT_APP_DISPERSE_MULTI_SENDER_CONTRACT_ADDRESS;

export const DISPERSE_MULTI_SENDER_TOKEN_ADDRESS_KAB = process.env.REACT_APP_DISPERSE_MULTI_SENDER_TOKEN_ADDRESS_KAB;
export const DISPERSE_MULTI_SENDER_TOKEN_ADDRESS_OKG = process.env.REACT_APP_DISPERSE_MULTI_SENDER_TOKEN_ADDRESS_OKG;

